import {
  pageInfoNursingCareInsurance,
  topicNursingCareInsurance,
} from "../../PageData/Info/infoNursingCareInsurance";
import { GridLayout, PageBodyContainer, Topic } from "../../components";

const NursingCareInsurance = () => {
  return (
    <PageBodyContainer pageInfo={pageInfoNursingCareInsurance}>
      <GridLayout md={[12]} xs={[12]} spacing={6} style={{ marginTop: 32 }}>
        {topicNursingCareInsurance.map((topic, index) => {
          return (
            <Topic
              topic={topic}
              id={`nursingCareInsurancePageTopic${index}`}
            ></Topic>
          );
        })}
      </GridLayout>
    </PageBodyContainer>
  );
};

export default NursingCareInsurance;
